import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class OrganizationIdInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip auth endpoints
    if (request.url.includes('/auth')) {
      return next.handle(request);
    }

    // Leer organizationId de localStorage
    const organizationId = localStorage.getItem('organizationId') || '';

    // Clonar request y agregar cabecera
    const clonedRequest = request.clone({
      setHeaders: {
        'X-Organization-ID': organizationId,
      },
    });

    return next.handle(clonedRequest);
  }
}
